import { render } from "./CustomizeRatesModal.vue?vue&type=template&id=2dbbf439&scoped=true&ts=true"
import script from "./CustomizeRatesModal.vue?vue&type=script&lang=ts"
export * from "./CustomizeRatesModal.vue?vue&type=script&lang=ts"

import "./CustomizeRatesModal.vue?vue&type=style&index=0&id=2dbbf439&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbbf439"]])

export default __exports__